export default function Contact() {
    const name = "contact";
    const typeCode = 2;
    const fields = {
        "firstname":"firstname",
        "lastname":"lastname",
        "fullname":"fullname",
        "gendercode":"gendercode",
        // "kphwlm_nationalcode":"kphwlm_nationalcode",
        "emailaddress1":"emailaddress1",
        "birthdate":"birthdate",
        "contactid":"contactid",
        "mobilephone":"mobilephone",
        "entityimage":"entityimage",
    }
    return{name, typeCode, fields}
}